KMVP.tooltips = {

    stayOnHover: {
        timeout: 300
    },
    $tooltips: null,

    bindTooltips: function ($container) {

        $container = $container || $('body');
        $tooltips = $container.find('.js-tooltip-popover');

        $tooltips.each(function () {
            var $this = $(this);

            if ($this.hasClass('js-initialized')) {
                return true;
            }
            $this.addClass('js-initialized'); // assuming initialization will work

            var $content = $this.find('.js-tooltip-content'),
                // When the user moves his mouse into the popover, it normally disappears. Set to true if popover should stay visible.
                stayOnHover = $this.data('stayonhover') || false,
                tooltipIdClass = stayOnHover ? KMVP.tooltips._getRandomClass() : "",
                toolTipClass = ($content.data('tooltip-class') || "") + " " + tooltipIdClass,
                toolTipContainerClass = $content.data('container'),
                template =
                    '<div class="popover ' + toolTipClass + '" role="tooltip">' +
                    '<div class="arrow"></div>' +
                    '<div class="popover-header"></div>' +
                    '<div class="popover-body"></div>' +
                    '</div>';

            $this.popover({
                html: true,
                template: template,
                title: $this.data('title'),
                content: $content.html(),
                animation: !stayOnHover,
                container: toolTipContainerClass,
                placement: $this.data('placement'),
                trigger: stayOnHover ? 'manual' : $this.data('trigger') || 'hover focus'
            });

            if (stayOnHover) {
                KMVP.tooltips._initStayOnHover($this, tooltipIdClass);
            }

            $content.remove();
        });

        $(document).on('click', function (e) {
            var $target = $(e.target);
            if ($target.hasClass('js-tooltip-popover') ||
                $target.closest('.js-tooltip-popover').length > 0 ||
                $target.closest('.popover').length > 0) {
                return;
            }
            $('.js-tooltip-popover').popover('hide');
        });
    },

    _initStayOnHover: function($popoverTrigger, tooltipIdClass) {
        // customized from https://stackoverflow.com/questions/15989591/how-can-i-keep-bootstrap-popover-alive-while-the-popover-is-being-hovered
        var triggerId = KMVP.tooltips._getRandomClass();
        var $instanceTooltips = $tooltips; // we have no module, so copy into local scope (potentially unsafe)

        $popoverTrigger.addClass(triggerId);

        $popoverTrigger.on('mouseenter', function () {
            $instanceTooltips.popover('hide'); // hide previously visible tooltips instantly (not considering timeout)
            $(this).popover('show');
        }).on('mouseleave', function () {
            KMVP.tooltips._closeIfNotHovered(tooltipIdClass, triggerId);
        });

        // we have to register on document, because the element does not yet exist when this method is called
        $(document).on('mouseleave', '.' + tooltipIdClass, function () {
            KMVP.tooltips._closeIfNotHovered(tooltipIdClass, triggerId);
        });
    },

    _closeIfNotHovered: function (tooltipIdClass, triggerClass) {
        setTimeout(function () {
            if (!$('.' + tooltipIdClass + ':hover').length && !$('.' + triggerClass + ':hover').length) {
                $('.' + triggerClass).popover('hide');
            }
        }, KMVP.tooltips.stayOnHover.timeout);
    },

    _getRandomClass: function () {
        return "id-" + Math.floor(Date.now() * Math.random());
    },

    handlePopoverCloseClick: function (e) {
        $('.js-tooltip-popover[aria-describedby=' + $(e.currentTarget).closest('.popover').attr('id') + ']').popover('hide');
    },

    activateBoostrapPopover: function () {
        $("[data-toggle=popover]").popover();
    }
};

$(document).ready(function () {
    KMVP.tooltips.bindTooltips();
    KMVP.tooltips.activateBoostrapPopover();
});
